import { render } from "./BlockTitle.vue?vue&type=template&id=618ee510&scoped=true"
import script from "./BlockTitle.vue?vue&type=script&lang=js"
export * from "./BlockTitle.vue?vue&type=script&lang=js"

import "./BlockTitle.vue?vue&type=style&index=0&id=618ee510&lang=postcss&scoped=true"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-618ee510"]])

export default __exports__